import type { DayPickerLocale } from "react-day-picker";
import { useTranslation } from "react-i18next";
import { enUS, fr } from "react-day-picker/locale";

export default function useGetDayPickerLocale(): DayPickerLocale {
  const { i18n } = useTranslation();

  switch (i18n.language.substring(0, 2)) {
    case "en":
      return enUS;
    case "fr":
      return fr;
    default:
      throw new Error("Unsupported language locale");
  }
}
